export const INDIA_STATES_TAMIL = [
    /*{ value: "Andhra Pradesh", label: "ஆந்திரப் பிரதேசம் (Andhra Pradesh)" },
    { value: "Arunachal Pradesh", label: "அருணாசலப் பிரதேசம் (Arunachal Pradesh)" },
    { value: "Assam", label: "அசாம் (Assam)" },
    { value: "Bihar", label: "பிகார் (Bihar)" },
    { value: "Chhattisgarh", label: "சத்தீஸ்கர் (Chhattisgarh)" },
    { value: "Goa", label: "கோவா (Goa)" },
    { value: "Gujarat", label: "குஜராத் (Gujarat)" },
    { value: "Haryana", label: "ஹரியானா (Haryana)" },
    { value: "Himachal Pradesh", label: "ஹிமாச்சலப் பிரதேசம் (Himachal Pradesh)" },
    { value: "Jharkhand", label: "ஜார்க்கண்ட் (Jharkhand)" }, */
    { value: "Karnataka", label: "கர்நாடகா (Karnataka)" },
    /*{ value: "Kerala", label: "கேரளா (Kerala)" },
    { value: "Madhya Pradesh", label: "மத்தியப் பிரதேசம் (Madhya Pradesh)" },
    { value: "Maharashtra", label: "மகாராஷ்டிரா (Maharashtra)" },
    { value: "Manipur", label: "மணிப்பூர் (Manipur)" },
    { value: "Meghalaya", label: "மேகாலயா (Meghalaya)" },
    { value: "Mizoram", label: "மிசோராம் (Mizoram)" },
    { value: "Nagaland", label: "நாகாலாந்து (Nagaland)" },
    { value: "Odisha", label: "ஒடிஷா (Odisha)" },
    { value: "Punjab", label: "பஞ்சாப் (Punjab)" },
    { value: "Rajasthan", label: "ராஜஸ்தான் (Rajasthan)" },
    { value: "Sikkim", label: "சிக்கிம் (Sikkim)" },*/
    { value: "Tamil Nadu", label: "தமிழ்நாடு (Tamil Nadu)" },
    /*{ value: "Telangana", label: "தெலுங்கானா (Telangana)" },
    { value: "Tripura", label: "திரிபுரா (Tripura)" },
    { value: "Uttar Pradesh", label: "உத்தரப் பிரதேசம் (Uttar Pradesh)" },
    { value: "Uttarakhand", label: "உத்தராகண்ட் (Uttarakhand)" },
    { value: "West Bengal", label: "மேற்கு வங்காளம் (West Bengal)" },*/

    // UNION TERRITORIES
    /*{ value: "Andaman and Nicobar Islands", label: "அந்தமான் நிக்கோபார் தீவுகள் (Andaman and Nicobar Islands)" },
    { value: "Chandigarh", label: "சண்டிகர் (Chandigarh)" },
    { value: "Dadra and Nagar Haveli and Daman and Diu", label: "தாத்ரா & நகர் ஹவேலி, தாமன் & தியூ (Dadra & Nagar Haveli and Daman & Diu)" },
    { value: "Delhi", label: "டெல்லி (Delhi)" },
    { value: "Jammu and Kashmir", label: "ஜம்மு & காஷ்மீர் (Jammu and Kashmir)" },
    { value: "Ladakh", label: "லடாக் (Ladakh)" },
    { value: "Lakshadweep", label: "லட்சத்தீவு (Lakshadweep)" },*/
    { value: "Puducherry", label: "புதுச்சேரி (Puducherry)" }
];
